module.exports = __webpack_public_path__ + "static/media/18ECA28.1c37c523.jpg";